import React from "react";
import BackDrop from "../ui/BackDrop";
import { cn } from "../../utils/twMerge";
import CustomDateInput from "../ui/custom-date-input/CustomDateInput";

import { datePickerIcon, closeIcon } from "../../assetData/icons";
import MirageLoader from "../ui/pageLoader/MirageLoader";

const MasterAdd = (props) => {
  const {
    form,
    segmentName,
    addHandler,
    closeHandler,
    shortNameRequired,
    isButtonClicked,
  } = props;

  const errors = form.formState.errors;

  const onSubmit = async (data) => {
    const statusValue = form.getValues("status") === "true";
    const updatedData = { ...data, status: statusValue };

    const res = await addHandler(updatedData);
    if (res) closeHandler();
  };

  const onClose = () => {
    closeHandler();
  };

  form.watch();

  return (
    <>
      <div className="fixed left-1/2 top-1/2 z-50 mx-auto min-h-[300px] w-[98%] max-w-[1000px] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-8">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">{`Add ${segmentName}`}</h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form.handleSubmit(onSubmit)}>
          {/* row 1 */}
          <div className="gap-2 md:flex">
            <div className={cn("flex w-full flex-col  gap-2")}>
              <label className="text-base text-[#636363]">
                {segmentName} Name *
              </label>
              <input
                placeholder=""
                {...form.register("name")}
                className={cn(
                  "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                  errors.name && "border-[1px] border-red-300",
                )}
              />
            </div>

            <div className={cn("flex w-full flex-col gap-2  max-md:mt-4")}>
              <label className="text-base text-[#636363]">
                Short Name {shortNameRequired && "*"}
              </label>
              <input
                placeholder=""
                {...form.register("short_name")}
                className={cn(
                  "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                  errors.short_name && "border-[1px] border-red-300",
                )}
              />
            </div>

            <div className="flex h-full w-full  flex-col gap-2 max-md:mt-4">
              <label className="text-[#636363]">Status</label>
              <div
                className={cn(
                  " h-full rounded bg-neutral-100 px-2 py-[9px]",
                  errors.status && "border-[1px] border-red-300",
                )}
              >
                <select
                  {...form.register("status")}
                  className=" w-full  bg-transparent px-2 text-[#636363] focus:outline-none"
                  defaultValue={true}
                  disabled
                >
                  <option value={true}>Active</option>
                  <option value={false}>Inactive</option>
                </select>
              </div>
            </div>
          </div>

          {/* row 2 */}
          <div className="mt-8 items-end gap-2 max-md:mt-4 md:flex ">
            <div className=" flex w-full items-stretch gap-4 text-neutral-600">
              <div className="flex w-full  flex-col gap-2 ">
                <label>Start date *</label>
                <CustomDateInput
                  initialValue={form.getValues("eff_start_date")}
                  handleSetValue={(val) => {
                    form.setValue("eff_start_date", val);
                    form.clearErrors("eff_start_date");
                  }}
                  className={cn(
                    " h-full w-full rounded bg-neutral-100 p-2 px-2 text-[#636363] focus:outline-none",
                    errors.eff_start_date && "border-[1px] border-red-300",
                  )}
                />
              </div>
            </div>

            <div className="flex w-full items-stretch gap-4 text-neutral-600 max-md:mt-4">
              <div className="flex w-full  flex-col gap-2 ">
                <label>End date</label>
                <CustomDateInput
                  min={form.getValues("eff_start_date")}
                  initialValue={form.getValues("eff_end_date")}
                  handleSetValue={(val) => {
                    form.setValue("eff_end_date", val);
                    form.clearErrors("eff_end_date");
                  }}
                  className={cn(
                    " h-full w-full rounded bg-neutral-100 p-2 px-2 text-[#636363] focus:outline-none",
                    errors.eff_end_date && "border-[1px] border-red-300",
                  )}
                />
              </div>
            </div>

            <div className="mt-8 flex w-full items-stretch gap-4 text-neutral-600"></div>
          </div>
          <div className="flex items-end gap-2 max-md:justify-center md:justify-between max-md:[&>button]:w-[70%] max-sm:[&>button]:w-full md:[&>button]:w-1/3">
            <button
              type="submit"
              disabled={isButtonClicked}
              className={` ${
                isButtonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-16 py-2 font-semibold text-white `}
            >
              {isButtonClicked ? <MirageLoader /> : "ADD"}
            </button>
            <button className="max-md:hidden"></button>
            <button className="max-md:hidden"></button>
          </div>
        </form>
      </div>
      <BackDrop />
    </>
  );
};

export default MasterAdd;
